// This is now a placeholder for future logging
export const logInteraction = name => {
  // New Relic is deprecated as of 12/10/20.  NR account expires 12/25/20
  // @TODO remove this code after 12/25/20
  // if (window.newrelic) {
  //   window.newrelic
  //     .interaction()
  //     .setName(name)
  //     .save()
  // }
}
